import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-44afff62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "navbar",
  class: "navbar navbar-expand-lg bg-white sticky-top"
}
const _hoisted_2 = { class: "container-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Magneto Renewable Energy logo",
  class: "img-fluid"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#Nav",
  "aria-controls": "Nav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse justify-content-end",
  id: "Nav"
}
const _hoisted_6 = { class: "navbar-nav my-3 my-lg-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: {name: 'ResidentialHome'}
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            "aria-current": "page",
            to: {name: 'ResidentialAboutUs'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("About Us")
            ]),
            _: 1
          }),
          _hoisted_7,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ResidentialProductRange'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Products")
            ]),
            _: 1
          }),
          _hoisted_8,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ResidentialSolutions'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Solutions")
            ]),
            _: 1
          }),
          _hoisted_9,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ResidentialContactUs'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact Us")
            ]),
            _: 1
          }),
          _hoisted_10,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ResidentialWarrantyRegistration'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Register Your Warranty")
            ]),
            _: 1
          }),
          _hoisted_11,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: {name: 'Home'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Commercial")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}